/**
 * Returns a closure for the javascript prototype sort method on an object.
 *
 * @example items.sort(sortByKey('name'));
 *
 * @param key
 */
export const sortByKey = (key) => {
    return (a, b) => {
        if (a[key] < b[key]) {
            return -1;
        }
        if (a[key] > b[key]) {
            return 1;
        }
        return 0;
    };
};
/**
 * Filters an array of objects based on a unique key in the object.
 *
 * @param rows
 * @param key
 */
export const unique = (rows, key) => {
    if (!rows) {
        return [];
    }
    return rows.filter((row, index, array) => {
        return array.map((mapItem) => {
            return mapItem[key];
        }).indexOf(row[key]) === index;
    });
};
